import { DashboardService } from 'src/app/modules/dashboard/services/dashboard.service';
import { Component, HostListener, OnInit, Renderer2, ViewChild, ElementRef, OnChanges, SimpleChanges, OnDestroy, AfterViewInit, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertModalService } from 'src/app/shared/services/alert-modal.service';
import { CommonService } from 'src/app/_services/common.service';
import { appConfig } from 'src/app/_core/config/app-config.const';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';
import { environment } from 'src/environments/environment';
import { NgNavigatorShareService } from 'ng-navigator-share';
import { ToastrService } from 'ngx-toastr';
import { TinyUrlService } from '../../services/tinyurl.service';
import _Swal from 'sweetalert2';

@Component({
  selector: 'my-tangram',
  templateUrl: './my-tangram.component.html',
  styleUrls: ['./my-tangram.component.scss'],
})
export class MyTangramComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @ViewChild('EmbedModalPopupContent', { static: true }) embedModalPopupContent!: TemplateRef<any>;
  @ViewChild('scrollSentinel', { static: false }) scrollSentinel: ElementRef;

  imgPath = appConfig.imagePath;
  iconPath = appConfig.iconPath;
  myTangramList: any[];
  allTangramList: any[] = [];
  activeFilter: 'all' | 'published' | 'drafts' = 'all';
  draftsCount: number = 0;
  publishedCount: number = 0;
  totalTangramCount: number = 0;

  // Pagination / infinite scroll state
  currentPage: number = 1;
  pageSize: number = 12;
  isLoading: boolean = false;
  hasMorePages: boolean = true;
  private sentinelObserver: IntersectionObserver | null = null;

  showSideMenuBar: boolean = false;
  currentUser: any;
  placeholderImage: string = "assets/img/videos/img6.png";
  shareUrl: string = '';
  fbShareUrl: string = '';
  inAppShareUrl:string = '';
  whatsAppShareUrl: string = '';
  whatsAppShareUrl1: string = '';
  CurrentSharePathwayId: string = '';
  imgEnvPath = environment.backendUrl;
  private ngNavigatorShareService: NgNavigatorShareService;
  currentPathwayId = ''
  showFeedbackModal: boolean = false;
  isIOS: boolean = false

  sortBy: 'recent' | 'views' | 'title' = 'recent';
  sortMenuOpen: boolean = false;
  viewMode: 'grid' | 'list' = 'grid';
  openMenuId: string = '';
  totalViews: number = 0;
  totalVisitors: number = 0;
  totalFavorites: number = 0;
  totalComments: number = 0;

  constructor(
    private modalService: NgbModal,
    private cd: ChangeDetectorRef,
    private renderer: Renderer2,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private dashboardService: DashboardService,
    ngNavigatorShareService: NgNavigatorShareService,
    private toasterService: ToastrService,
    private tinyUrlService: TinyUrlService,
    private alertModalService: AlertModalService,
    ) {
      this.currentUser = this.authService.currentUserValue;
      this.ngNavigatorShareService = ngNavigatorShareService;
    }

  ngOnChanges(_changes: SimpleChanges) {}

  ngOnInit() {
    this.loadPage(1);

    this.fbShareUrl = environment.fbShareUrl;
    this.inAppShareUrl = environment.inAppShareUrl;
    const details = navigator.userAgent;
    const regexp = /android|iphone|kindle|ipad/i;
    this.isIOS = /iphone|ipad/i.test(navigator.userAgent);
    const isMobileDevice = regexp.test(details);
    if (isMobileDevice) {
      this.whatsAppShareUrl = environment.whatsAppShareUrlMobile;
    } else {
      this.whatsAppShareUrl = environment.whatsAppShareUrl;
    }
  }

  ngAfterViewInit() {
    this.setupSentinelObserver();
  }

  /** Set up IntersectionObserver on the bottom sentinel div. */
  private setupSentinelObserver() {
    if (!('IntersectionObserver' in window)) {
      // Fallback: load all pages via scroll listener
      return;
    }
    this.sentinelObserver = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !this.isLoading && this.hasMorePages) {
          this.loadPage(this.currentPage + 1);
        }
      },
      { rootMargin: '200px' }
    );
    if (this.scrollSentinel && this.scrollSentinel.nativeElement) {
      this.sentinelObserver.observe(this.scrollSentinel.nativeElement);
    }
  }

  /** Load a specific page from the paginated API. */
  loadPage(page: number) {
    if (this.isLoading || (!this.hasMorePages && page > 1)) return;
    this.isLoading = true;

    this.dashboardService.getMyTangramListPaginated(page, this.pageSize, this.activeFilter).subscribe((response: any) => {
      if (!response.success) {
        this.isLoading = false;
        return;
      }

      const raw: any[] = response.data || [];
      raw.forEach((el: any) => {
        if (el.imageURL) {
          el.overviewImageUrl = `${environment.backendUrl}${el.imageURL}`;
        } else if (el.tempImageURL) {
          el.overviewImageUrl = el.tempImageURL;
        } else {
          el.overviewImageUrl = 'assets/img/videos/img6.png';
        }
      });

      if (page === 1) {
        // First page — reset and populate counts from API metadata
        this.allTangramList = raw.filter((el: any) => el.isDraft || el.totalVideos);
        if (response.pagination) {
          this.totalTangramCount = response.pagination.totalCount;
          this.draftsCount       = response.pagination.draftsCount;
          this.publishedCount    = response.pagination.publishedCount;
          this.hasMorePages      = response.pagination.hasMore;
        }
        this.currentPage = 1;
        this.loadTangramExtras(this.allTangramList);
      } else {
        // Subsequent pages — append
        const newItems = raw.filter((el: any) => el.isDraft || el.totalVideos);
        this.allTangramList = [...this.allTangramList, ...newItems];
        if (response.pagination) {
          this.hasMorePages = response.pagination.hasMore;
        }
        this.currentPage = page;
        this.loadTangramExtras(newItems);
      }

      this.applyFilter();
      this.isLoading = false;
      this.cd.detectChanges();

      // Re-observe sentinel after DOM updates (view may have added it for the first time)
      if (this.scrollSentinel && this.scrollSentinel.nativeElement && this.sentinelObserver) {
        this.sentinelObserver.observe(this.scrollSentinel.nativeElement);
      }
    }, () => {
      this.isLoading = false;
    });
  }

  /**
   * Fetch star ratings and completion data for a given subset of tangrams.
   */
  loadTangramExtras(items: any[]) {
    if (!items || !items.length || !this.currentUser) return;
    const pathwayIds = items.map(t => t._id);

    this.dashboardService.getBatchStarRatings(pathwayIds).subscribe((res: any) => {
      if (res.success) {
        this.allTangramList.forEach(tangram => {
          const rating = res.data[tangram._id];
          if (rating) {
            tangram.averageStarRating = rating.averageRating || 0;
            tangram.userStarRating    = rating.userRating || 0;
            tangram.totalStarRatings  = rating.totalRatings || 0;
          }
        });
        this.applyFilter();
      }
    });

    this.dashboardService.getBatchMediaCompletions(pathwayIds).subscribe((res: any) => {
      if (res.success) {
        this.allTangramList.forEach(tangram => {
          const completion = res.data[tangram._id];
          if (completion) {
            tangram.completedCount        = (completion.completedVideoIds || []).length;
            tangram.completionPercentage  = completion.completionPercentage || 0;
          }
        });
      }
    });
  }

  toggleSideMenuBar($event: Event) {
    $event.stopPropagation();
    this.showSideMenuBar = !this.showSideMenuBar;
    if (this.showSideMenuBar) {
      this.renderer.addClass(document.body, 'menu-open');
    } else {
      this.renderer.removeClass(document.body, 'menu-open');
    }
  }

  onClick(event) {
    if (this.showSideMenuBar) {
       this.toggleSideMenuBar(event);
    } else {
      this.renderer.removeClass(document.body, 'menu-open');
    }
  }

  createTangram() {
    this.router.navigate(['/create-tangram']);
  }

  navigateToPathwayDetails(pathway: any) {
    const pathwayId = pathway._id;
    if (pathway && pathway.isDraft) {
      this.router.navigate(['/edit-tangram', pathwayId]);
    } else {
      this.router.navigate(['/dashboard', pathwayId]);
    }
  }

  setFilter(filter: 'all' | 'published' | 'drafts') {
    if (this.activeFilter === filter) { return; }
    this.activeFilter = filter;
    // Each tab paginates over its own server-side subset, so reset the loaded
    // list and reload page 1. (Client-only filtering previously showed just the
    // few matching rows on the already-loaded pages — e.g. 1 of 251 published.)
    this.allTangramList = [];
    this.myTangramList = [];
    this.currentPage = 0;
    this.hasMorePages = true;
    this.loadPage(1);
  }

  setSort(sort: 'recent' | 'views' | 'title') {
    this.sortBy = sort;
    this.sortMenuOpen = false;
    this.applyFilter();
  }

  toggleSortMenu(event: Event) {
    event.stopPropagation();
    this.sortMenuOpen = !this.sortMenuOpen;
    if (this.openMenuId) { this.openMenuId = ''; }
  }

  getSortLabel(): string {
    const labels: Record<string, string> = { recent: 'Recently edited', views: 'Most views', title: 'Title' };
    return labels[this.sortBy] || 'Recently edited';
  }

  toggleCardMenu(id: string, event?: Event) {
    if (event) { event.stopPropagation(); }
    this.openMenuId = this.openMenuId === id ? '' : id;
  }

  @HostListener('document:click')
  closeCardMenuOnOutsideClick() {
    if (this.openMenuId) { this.openMenuId = ''; }
    if (this.sortMenuOpen) { this.sortMenuOpen = false; }
  }

  private sumField(field: string): number {
    if (!this.allTangramList) { return 0; }
    return this.allTangramList.reduce((sum: number, t: any) => {
      const v = Number(t && t[field]);
      return sum + (isNaN(v) ? 0 : v);
    }, 0);
  }

  private applyFilter() {
    if (!this.allTangramList) {
      this.myTangramList = [];
      this.totalViews = 0;
      this.totalVisitors = 0;
      this.totalFavorites = 0;
      this.totalComments = 0;
      return;
    }
    let next: any[];
    if (this.activeFilter === 'drafts') {
      next = this.allTangramList.filter((t: any) => t.isDraft);
    } else if (this.activeFilter === 'published') {
      next = this.allTangramList.filter((t: any) => !t.isDraft);
    } else {
      next = [...this.allTangramList];
    }

    if (this.sortBy === 'views') {
      next.sort((a: any, b: any) => (Number(b.totalViewCount) || 0) - (Number(a.totalViewCount) || 0));
    } else if (this.sortBy === 'title') {
      next.sort((a: any, b: any) => (a.title || '').localeCompare(b.title || ''));
    }
    this.myTangramList = next;

    this.totalViews     = this.sumField('totalViewCount');
    this.totalVisitors  = this.sumField('users');
    this.totalFavorites = this.sumField('totalStarRatings');
    this.totalComments  = this.sumField('totalCommentCount');
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/home']);
  }

  ngOnDestroy() {
    if (this.sentinelObserver) {
      this.sentinelObserver.disconnect();
    }
  }

  shareRedirect(appUrl, link) {
    const shareURL = appUrl + encodeURIComponent(link);
    window.open(shareURL, 'popup', 'width=600,height=600');
    return false;
  }

  copyLink(_type) {
    const link = this.shareUrl;
    navigator.clipboard.writeText(link);
  }

  async openSharePopup(pathwayId) {
    if (this.CurrentSharePathwayId && this.CurrentSharePathwayId !== pathwayId) {
      const popup = document.getElementById('share-popup' + this.CurrentSharePathwayId);
      const btnPopup = document.getElementById('shareBtn' + this.CurrentSharePathwayId);
      if (popup) { popup.classList.toggle('show'); }
      if (btnPopup) { btnPopup.classList.toggle('visible'); }
    }
    // Current origin → link matches the running environment (localhost /
    // staging / production), not the hardcoded appRedirectUrl.
    const link = window.location.origin + '/#/dashboard/' + pathwayId;
    this.shareUrl = await this.shortenUrlFunc(link);
    const urlInput = document.getElementById('share-tangram-url' + pathwayId);
    if (urlInput) urlInput.setAttribute('value', this.shareUrl);
    const popup = document.getElementById('share-popup' + pathwayId);
    const btnPopup = document.getElementById('shareBtn' + pathwayId);
    if (this.isIOS) {
      this.ngNavigatorShareService.share({ title: '', url: this.shareUrl })
        .then(r => console.log(r)).catch(e => console.log(e));
    } else {
      if (popup) { popup.classList.toggle('show'); }
      if (btnPopup) { btnPopup.classList.toggle('visible'); }
    }
    if (!(this.CurrentSharePathwayId && this.CurrentSharePathwayId === pathwayId)) {
      this.CurrentSharePathwayId = pathwayId;
    }
  }

  openShareModal(content) {
    this.modalService.open(content, { centered: true }).result.then(() => {}, () => {});
  }

  updateOverviewImageUrl(event, i) {
    this.myTangramList[i].overviewImageUrl = 'assets/img/videos/img6.png';
  }

  async shortenUrlFunc(longUrl) {
    try {
      const response: any = await this.tinyUrlService.shortenUrl(longUrl).toPromise();
      return response.data.tiny_url;
    } catch (error) {
      console.error('Error shortening URL:', error);
      this.toasterService.error(error);
      return longUrl;
    }
  }

  showPopup(pathwayId, modalContent: TemplateRef<any>) {
    if (!this.currentUser.subscriptionActive) {
      this.modalService.open(modalContent, { centered: true, windowClass: 'unlock-premium' });
      return;
    }
    this.currentPathwayId = pathwayId;
    this.alertModalService.confirm({
      title: 'Delete Tangram',
      message: 'Do you want to delete this tangram ?',
      cancelText: 'No',
      confirmText: 'Yes, Delete',
    }).subscribe(confirmed => { if (confirmed) this.deleteTangram(); });
  }

  deleteTangram() {
    const data = { pathwayId: this.currentPathwayId };
    this.dashboardService.deleteTangram(data).subscribe((res: any) => {
      if (res.success) {
        const removed = this.allTangramList.find((t: any) => t._id === this.currentPathwayId);
        this.allTangramList = this.allTangramList.filter(t => t._id !== this.currentPathwayId);
        if (removed) {
          this.totalTangramCount = Math.max(0, this.totalTangramCount - 1);
          if (removed.isDraft) {
            this.draftsCount = Math.max(0, this.draftsCount - 1);
          } else {
            this.publishedCount = Math.max(0, this.publishedCount - 1);
          }
        }
        this.applyFilter();
        this.currentPathwayId = '';
      }
    });
  }

  openEmbedModal(pathwayId: string) {
    this.CurrentSharePathwayId = pathwayId;
    this.modalService.open(this.embedModalPopupContent, {
      centered: true,
      windowClass: 'embed-modal-popup',
      size: 'lg'
    });
  }
}
